import { render } from "./Avatar.vue?vue&type=template&id=f30e9cf6&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=f30e9cf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f30e9cf6"

export default script